<template>
  <b-button
    size="sm"
    @click="$emit('click')" 
    variant="outline-secondary"
    v-b-tooltip.hover.d-md-none
    :title="titleText"
  >
    <b-icon :icon="iconName" ></b-icon>
    <span class="d-none d-md-inline ms-1">{{ titleText }}</span>
  </b-button>
</template>

<script>
export default {
  name: 'ToggleDetailsButton',
  
  props: {
    showing: {
      type: Boolean,
      default: false
    },

    variant: {
      type: String,
      default: 'secondary'
    }
  },

  computed: {
    titleText() {
      return this.showing ? 'Ocultar' : 'Ver'
    },

    iconName() {
      return this.showing ? 'eye-slash-fill' : 'eye-fill'  
    },
  }
}
</script>